/*
 * @Author: Liux
 * @Date: 2019-09-24 03:30:07
 * @LastEditor: Liux
 * @LastEditTime : 2020-01-17 14:03:46
 */
import { InjectionToken, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavigationStart, Router } from '@angular/router';
import {
  BasicComponentModule,
  DateRange_Fommat_CONFIG,
  DATE_PICKER_CONFIG_DATA,
} from 'basic-component';
import { DashboardModule } from 'dashboard';
import { SectionModule } from 'section';
import { CancelService } from 'src/app/infrastructure';
import { ServiceModule, InfoService } from 'src/app/domain/service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonServiceModule } from './common/services/common-service.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AUTH_CONFIG } from '@internal/rest/auth';
import { ILOADING_SPINNER } from '@internal/dsf-shared/shared-modules/common/services';
import { LoadingService } from '@internal/rest/rest';
import { enUS } from 'date-fns/locale';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { InsightsModule } from './infrastructure/service/insights/insights.module';


@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BasicComponentModule.forRoot([
      {
        provide: DateRange_Fommat_CONFIG,
        useFactory: (loginfo: InfoService) => {
          return { format: loginfo.getDateFormat() };
        },
        deps: [InfoService],
      },
      {
        provide: DATE_PICKER_CONFIG_DATA,
        useFactory: (loginfo: InfoService) => {
          return { format: loginfo.getDateFormat() };
        },
        deps: [InfoService],
      },
    ]),
    BrowserModule,
    DashboardModule,
    FormsModule,
    SectionModule,
    ServiceModule,
    CommonServiceModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    InsightsModule
  ],
  providers: [
    { provide: ILOADING_SPINNER, useExisting: LoadingService },
    {
      provide: MAT_DATE_LOCALE,
      useValue: enUS,
    },
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {
}
